var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carregar",class:_vm.classeTamanho},[_c('div',{staticClass:"c-loader"}),_c('p',[_vm._v("Carregando...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }